export { default } from './InlineMessage';
